<template>
	<v-dialog v-model="show" width="500">
	 <v-card flat class="px-3">
	 	<v-card-title class="headline">Confirm Changes to {{title}} </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 body-2">
        	The following changes will be made.</v-card-text>
        <v-list-tile class="mb-1 mx-2"	 			
	 		style="border-width: .5px !important; border-bottom: solid; border-color: grey; ">
        <v-layout row align-center class="body-2 ">
			<v-flex xs2 class="pl-1">ID</v-flex>
			<v-flex>Name</v-flex>
			<v-flex xs1 v-if="showSuper">Super</v-flex>
			<v-flex xs1></v-flex>
		</v-layout>
		</v-list-tile>
	 	<v-list class="confirmList pb-5 pr-2" dense >
			<v-list-tile v-for="(item, index) in changeArray" :key="index">			
				<v-layout row align-center>

					<v-flex xs2>						
					  	<v-text-field 
					  		class="body-1"                         
	                        v-model="item.id"
	                        label="ID"
	                        single-line  
	                        :readonly = "true" 
	                        flat solo    
	                        readonly
	                        hide-details                                       
	                        >                   
	                    </v-text-field>
					</v-flex>
					<v-flex>
						<v-edit-dialog @click.native.stop class="body-1"
	                            :return-value.sync="item.name"
	                            lazy>
	                            {{ item.name }} 
	                            
	                            <v-text-field style="width: 300px;"                   
	                              slot="input"
	                              v-model="item.name"
	                              label="Name"
	                              single-line
	                              readonly                            
	                              counter>
	                            </v-text-field>
                        </v-edit-dialog>						
					</v-flex>
					<v-flex xs1 v-if="showSuper" class="body-1">
						{{item.super}}							
					</v-flex>
					
				<v-flex xs1 class="px-2 text-xs-right">
						<v-tooltip top>		              				                
			                <v-icon small slot="activator" color="red lighten-2" @click="delItem(item, index)">close</v-icon>          
				            <span>Delete</span>
			            </v-tooltip>
					</v-flex>
				</v-layout>

			</v-list-tile>
		</v-list> 

		<v-card-actions>
          	<v-spacer></v-spacer>
          	<v-btn color="green darken-1" flat @click="$emit('cancel')">No</v-btn>
          	<v-btn color="green darken-1" flat 
          		@click.native="$emit('save')">Yes
      	 	 </v-btn>
        </v-card-actions>

	</v-card>
</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'confirmListChangesDialog',
data () {
	return {
	}
},

methods: {
	delItem: function (item, index) {
		console.log("Del")
		this.changeArray.splice(index, 1) // Remove from local memory
	},
},

computed: {
	showSuper: function () {
		const superList = [ 'Type Codes', 'Categories' ]
		if (JSON.stringify(superList).includes(this.title)) {
			return true
		}
	}
},

props: [ 'changeArray', 'show', 'title' ],

}

</script>

<style>
.confirmList .v-list__tile {
   align-items:  flex-start;
   min-height: unset !important;
   height: auto;
}


</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/confirmListChangesDialog.vue